<app-header></app-header>
<main id="main">
  <!-- ======= About Section ======= -->
  <section id="about" class="about">
    <div class="container" data-aos="fade-up">
      <div class="row gx-0 about-border">
        <div
          class="col-lg-8 d-flex flex-column justify-content-center p-4"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <h3>Why <span>Us?</span></h3>
          <div class="row">
            <div class="col-md-6">
              <div class="icon">
                <img src="../../../assets/img/about-1.svg" />
              </div>
              <div class="content">
                <h4>Fast & Secure booking</h4>
                <p>
                  Hire a truck instantly. Book online or just call us. Truck
                  will be at your pickup point
                </p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="icon">
                <img src="../../../assets/img/about-2.svg" />
              </div>
              <div class="content">
                <h4>Economical Pricing</h4>
                <p>
                  No more bargaining with the local drivers. Transparent
                  point-to-point billing.
                </p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="icon">
                <img src="../../../assets/img/about-3.svg" />
              </div>
              <div class="content">
                <h4>Professional Services</h4>
                <p>
                  Your consignment is handled & moved through verified drivers &
                  audited vehicles.
                </p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="icon">
                <img src="../../../assets/img/about-4.svg" />
              </div>
              <div class="content">
                <h4>Reliable Tracking</h4>
                <p>
                  Real time tracking & distance measurement using GPS.
                  Persistent delivery status updates.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div
          class="col-lg-4 d-flex align-items-center"
          data-aos="zoom-out"
          data-aos-delay="200"
        >
          <img src="../../../assets/img/loree.png" class="img-fluid" alt="" />
        </div>
      </div>
    </div>
  </section>
  <!-- End About Section -->

  <!-- ======= Values Section ======= -->
  <section id="values" class="values pt-0">
    <div class="container" data-aos="fade-up">
      <header class="section-header">
        <h2>Our <span>Features</span></h2>
        <p>
          S9 (Siby Logistics Private Limited) caters to the transportation needs
          of individuals, Manufacturers, Traders, Wholesalers, E-commerce,
          Retail Shops or Builders across India.
        </p>
      </header>

      <div class="row">
        <div
          class="col-lg-8 d-flex flex-column justify-content-center p-4 pt-0"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <div class="row">
            <div class="col-lg-6" data-aos="fade-up" data-aos-delay="200">
              <div class="box">
                <div class="icon">
                  <img
                    src="../../../assets/img/features-icon.svg"
                    class="img-fluid"
                    alt=""
                  />
                </div>
                <div class="content">
                  <h4>Reliable Service</h4>
                  <p>
                    We value your business and understand how important it is
                    for you to transport your consignment
                  </p>
                  <a href="#">Read More.</a>
                </div>
              </div>
            </div>

            <div
              class="col-lg-6 mt-4 mt-lg-0"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              <div class="box">
                <div class="icon">
                  <img
                    src="../../../assets/img/features-icon.svg"
                    class="img-fluid"
                    alt=""
                  />
                </div>
                <div class="content">
                  <h4>Secured booking</h4>
                  <p>
                    With our simplified self intuitive online booking system,
                    booking a truck has never been easy.
                  </p>
                  <a href="#">Read More.</a>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6" data-aos="fade-up" data-aos-delay="200">
              <div class="box">
                <div class="icon">
                  <img
                    src="assets/img/features-icon.svg"
                    class="img-fluid"
                    alt=""
                  />
                </div>
                <div class="content">
                  <h4>No hidden charges</h4>
                  <p>
                    What you see on your quote is what you pay. We at
                    ViaeTruck.com maintain highest professional
                  </p>
                  <a href="#">Read More.</a>
                </div>
              </div>
            </div>

            <div
              class="col-lg-6 mt-4 mt-lg-0"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              <div class="box">
                <div class="icon">
                  <img
                    src="assets/img/features-icon.svg"
                    class="img-fluid"
                    alt=""
                  />
                </div>
                <div class="content">
                  <h4>Customer care</h4>
                  <p>
                    We are accessible any time. Our dedicated customer care team
                    will be more than happy to serve
                  </p>
                  <a href="#">Read More.</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-lg-4 d-flex align-items-center"
          data-aos="zoom-out"
          data-aos-delay="200"
        >
          <img src="assets/img/loree.png" class="img-fluid" alt="" />
        </div>
      </div>
    </div>
  </section>
  <!-- End Values Section -->

  <!-- ======= Number Section ======= -->
  <section id="support" class="about pt-0">
    <div id="mac" class="container" data-aos="fade-up">
      <div
        id="supportinfo"
        class="col-lg-12 contact-number-area"
        data-aos="fade-up"
        data-aos-delay="200"
      >
        <p>
          CALL US NOW ON
          <img src="assets/img/phone.svg" class="img-fluid" alt="" /><span
            >+91- 99666 34151</span
          >
          WE ARE OPEN <span>24/7</span> FOR ASSISTANCE
        </p>
      </div>
    </div>
  </section>

  <!-- ======= Features Section ======= -->
  <section id="features" class="features pt-0">
    <div class="container" data-aos="fade-up">
      <header class="section-header">
        <h2>Our <span>Beautiful Journey</span></h2>
      </header>

      <div class="row">
        <div class="col-lg-6 mt-5 mt-lg-0 d-flex">
          <div class="row align-self-center gy-4 feature-left-border">
            <div class="col-md-6" data-aos="zoom-out" data-aos-delay="200">
              <div class="icon">
                <img src="assets/img/india.svg" />
              </div>
              <div class="content">
                <h4>23</h4>
                <p>States</p>
              </div>
            </div>

            <div class="col-md-6" data-aos="zoom-out" data-aos-delay="300">
              <div class="icon">
                <img src="assets/img/india2.svg" />
              </div>
              <div class="content">
                <h4>72</h4>
                <p>Cities Nationality</p>
              </div>
            </div>

            <div class="col-md-6" data-aos="zoom-out" data-aos-delay="400">
              <div class="icon">
                <img src="assets/img/india3.svg" />
              </div>
              <div class="content">
                <h4>1</h4>
                <p>Happy Customer</p>
              </div>
            </div>

            <div class="col-md-6" data-aos="zoom-out" data-aos-delay="500">
              <div class="icon">
                <img src="assets/img/india4.svg" />
              </div>
              <div class="content">
                <h4>1</h4>
                <p>Total Transfer</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <img src="assets/img/journey.svg" class="img-fluid" alt="" />
        </div>
      </div>
      <!-- / row -->
    </div>
  </section>
  <!-- End Features Section -->

  <!-- ======= Contact Section ======= -->
  <!-- <section id="contact" class="contact">

      <div class="container" data-aos="fade-up">

        <header class="section-header">
          <h2>Quick <span>Contact</span></h2>
          <p>We love to listen and we are eagerly waiting to talk to you regarding your quote. Get in touch with us if you have any queries and we will get back to you as soon as possible.</p>
        </header>

        <div class="row gy-4">
          <div class="col-lg-12 mt-0">
            <form action="forms/contact.php" method="post" class="php-email-form">
              <div class="row gy-4">

                <div class="col-md-6">
                  <input type="text" name="name" class="form-control" placeholder="Your Name" required>
                </div>

                <div class="col-md-6 ">
                  <input type="email" class="form-control" name="email" placeholder="Your Email" required>
                </div>

                <div class="col-md-6">
                  <input type="text" class="form-control" name="subject" placeholder="Subject" required>
                </div>

                <div class="col-md-6">
                  <input type="text" class="form-control" name="subject" placeholder="Subject" required>
                </div>

                <div class="col-md-12">
                  <textarea class="form-control" name="message" rows="6" placeholder="Message" required></textarea>
                </div>

                <div class="col-md-12 text-center">
                  <div class="loading">Loading</div>
                  <div class="error-message"></div>
                  <div class="sent-message">Your message has been sent. Thank you!</div>

                  <button type="submit">Submit</button>
                </div>

              </div>
            </form>

          </div>

        </div>

      </div>

    </section> -->
  <!-- End Contact Section -->
</main>
<app-footer></app-footer>
